import classnames from 'classnames';
import type { TagOption } from 'components/shared/Tags/model';
import { CommodityMenuOption } from 'components/shared/underlyings/selector/result/Commodity';
import { CreditMenuOption } from 'components/shared/underlyings/selector/result/Credit';
import { EquityMenuOption } from 'components/shared/underlyings/selector/result/Equity';
import { ForexMenuOption } from 'components/shared/underlyings/selector/result/Forex';
import { RateMenuOption } from 'components/shared/underlyings/selector/result/Rate';
import type { Underlying } from 'models/underlying';
import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
import type { OptionProps } from 'react-select';
import {
  isCommodityUnderlying,
  isCreditUnderlying,
  isEquityUnderlying,
  isForexUnderlying,
  isRateUnderlying,
} from 'utils/underlying/typeGuards';

export function Option({ data, isFocused, selectOption }: OptionProps<TagOption<Underlying>, boolean>) {
  const underlying = data.rawValue as Underlying;

  return (
    <ScrollIntoViewIfNeeded
      active={isFocused}
      className={classnames('underlying-line clickable', {
        'table-active': isFocused,
      })}
      elementType="tr"
      onClick={() => selectOption(data)}
    >
      {isEquityUnderlying(underlying) && <EquityMenuOption {...underlying} />}
      {isCreditUnderlying(underlying) && <CreditMenuOption {...underlying} />}
      {isRateUnderlying(underlying) && <RateMenuOption {...underlying} />}
      {isForexUnderlying(underlying) && <ForexMenuOption {...underlying} />}
      {isCommodityUnderlying(underlying) && <CommodityMenuOption {...underlying} />}
      <td>{isFocused && <i className="icon icon-sm fw-bold">arrow_forward</i>}</td>
    </ScrollIntoViewIfNeeded>
  );
}
